import React from "react";
import Skeleton from '@mui/material/Skeleton';

export default function BlockSkeleton() {

  return (
    <Skeleton animation="wave" height="100%"/>
  );
}
